import React, { useState } from 'react';
import {
  Box, Button, TextField, Typography, Paper, Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig'; // Importamos la instancia configurada

const LoginPage = () => {
  const [id_usuario, setIdUsuario] = useState('');
  const [clave_usuario, setClaveUsuario] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  try {
    // ✅ Enviamos la contraseña en texto plano
    const res = await api.post('/login/', {
      id_usuario,
      contrasena: clave_usuario,  // ← ¡Texto plano!
    });
    if (res.data.success) {
      localStorage.setItem('user', res.data.user);
      localStorage.setItem('secciones', JSON.stringify(res.data.secciones));
      navigate('/');
    } else {
      setError(res.data.error || 'Error en login');
    }
  } catch (err) {
    setError('Error de conexión');
  }
};

  return (
    <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper sx={{ p: 4, width: 400 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Sistema POA
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Usuario"
            fullWidth
            value={id_usuario}
            onChange={(e) => setIdUsuario(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            value={clave_usuario}
            onChange={(e) => setClaveUsuario(e.target.value)}
            margin="normal"
            required
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Iniciar Sesión
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage;